import * as React from "react";
import { NavLink } from "react-router-dom";

const PollsPreviewSection = ({
  menuHierarchy,
  getParentMenuSortOrder,
  getParentMenuDisplayNumber,
  isParentMenuAvailable,
  completed_modules,
  in_array,
  t,
}) => {
  const surveyNode = Array.isArray(menuHierarchy)
    ? menuHierarchy.find((item) => item.alias === "survey")
    : null;

  return (
    <React.Fragment>
      {surveyNode && isParentMenuAvailable("survey") ? (
        <li
          key={`survey-${surveyNode.id}`}
          style={{
            order: getParentMenuSortOrder("survey"),
            counterSet: `section ${getParentMenuDisplayNumber("survey")}`,
          }}
          className={`${
            window.location.pathname.includes("event/manage/surveys") ||
            window.location.pathname.includes("event/manage/survey/questions")
              ? "bold activeList"
              : ""
          } ${Number(surveyNode.status) === 0 ? "lockscreen" : ""} ${
            in_array("survey", completed_modules) ? "completed" : ""
          }`}
        >
          <span>
            <NavLink to="/event/manage/surveys">
              {surveyNode.name || t("ES_NAME")}
            </NavLink>
          </span>
        </li>
      ) : null}
      <li
        style={{ order: 9999 }}
        className={
          window.location.pathname.includes("/event/preview")
            ? "bold activeList lastItem"
            : "lastItem"
        }
      >
        <span>
          <NavLink to="/event/preview">{t("PRV_PREVIEW")}</NavLink>
        </span>
      </li>
    </React.Fragment>
  );
};

export default PollsPreviewSection;
